/* AQUMIO · "Sepetinize ekleyin": tek dokunuşla ekleme + sepet çekmecesini yenileme (Dawn cart-drawer). */
(function () {
  if (window.aqSepetInit) return;
  window.aqSepetInit = true;

  function addUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }

  function onCartPage() {
    return !!document.querySelector('cart-items#main-cart-items, cart-items[id^="main-cart-items"]') ||
      /\/cart\/?$/.test(window.location.pathname);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aq-sepet-ekle]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var item = btn.closest('.aq-so__urun');
    var err = item && item.querySelector('.aq-so__hata');
    if (err) { err.hidden = true; err.textContent = ''; }
    btn.setAttribute('aria-busy', 'true');

    var drawer = document.querySelector('cart-drawer');
    var cartPage = onCartPage();
    var body = { id: Number(btn.getAttribute('data-aq-sepet-ekle')), quantity: 1 };
    if (drawer && !cartPage && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          btn.removeAttribute('aria-busy');
          if (err) { err.textContent = res.description || res.message || 'Ürün eklenemedi.'; err.hidden = false; }
          return;
        }
        if (cartPage || !drawer || typeof drawer.renderContents !== 'function' || !res.sections) {
          window.location.reload();
          return;
        }
        drawer.renderContents(res);
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        if (err) { err.textContent = 'Bağlantı hatası, lütfen tekrar deneyin.'; err.hidden = false; }
      });
  });

  /* Ürün seçilmemişse Shopify önerilerini yükle */
  function fetchInto(el, urls) {
    if (!urls.length) { el.remove(); return; }
    fetch(urls[0])
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var box = doc.querySelector('[data-aq-oneri-icerik]');
        if (box && box.querySelector('.aq-so__urun')) {
          var konum = el.getAttribute('data-konum');
          if (konum) box.className = 'aq-so aq-so--' + konum;
          el.replaceWith(box);
        } else {
          fetchInto(el, urls.slice(1));
        }
      })
      .catch(function () { el.remove(); });
  }
  function scan() {
    document.querySelectorAll('[data-aq-oneri-url]:not([data-aq-yuklendi])').forEach(function (el) {
      el.setAttribute('data-aq-yuklendi', '1');
      /* Aynı alanda sunucuda çizilmiş öneri listesi varsa yükleyiciyi kaldır */
      var parent = el.parentElement;
      if (parent && parent.querySelector('.aq-so .aq-so__urun')) { el.remove(); return; }
      var urls = [el.getAttribute('data-aq-oneri-url'), el.getAttribute('data-aq-oneri-url-2')].filter(Boolean);
      fetchInto(el, urls);
    });
  }
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || setTimeout)(function () { pending = false; scan(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  if ('MutationObserver' in window) {
    var start = function () {
      var targets = document.querySelectorAll('cart-drawer, cart-items');
      targets.forEach(function (t) { new MutationObserver(schedule).observe(t, { childList: true, subtree: true }); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }
})();

/* AQUMIO · İndirim kodu senkronu.
   /discount/KOD bağlantısı yalnızca 'discount_code' çerezini yazar; Shopify bu kodu ödemede uygular
   ama sepet nesnesine (cart.discount_codes) eklemez. Çerezdeki kod sepette yoksa
   /cart/update.js {discount: ...} ile sepete uygulanır, ardından çekmece / sepet sayfası yenilenir
   (gerçek indirim satırı ve tutarı Shopify'dan gelir). Kaynak: shopify.dev/docs/api/ajax/reference/cart */
(function () {
  if (window.aqIndirimInit) return;
  window.aqIndirimInit = true;
  var KAYNAK = 'aq-indirim';
  var deneme = {};
  var mesgul = false;

  function cerezKod() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]).trim(); } catch (e) { return m[1].trim(); }
  }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function sepetSayfasi() {
    return !!document.querySelector('cart-items#main-cart-items, cart-items[id^="main-cart-items"]');
  }

  function cekmeceyiYenile(res) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !res || !res.sections || typeof drawer.getSectionsToRender !== 'function') return false;
    drawer.getSectionsToRender().forEach(function (s) {
      var html = res.sections[s.id];
      var hedef = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!html || !hedef) return;
      var kaynak = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector || '.shopify-section');
      if (kaynak) hedef.innerHTML = kaynak.innerHTML;
    });
    var ic = drawer.querySelector('.drawer__inner');
    if (ic && res.item_count > 0) ic.classList.remove('is-empty');
    /* Dawn çekmece kaplamasına (overlay) tıklayınca kapanma davranışını koru */
    var ov = drawer.querySelector('#CartDrawer-Overlay');
    if (ov && typeof drawer.close === 'function') ov.addEventListener('click', drawer.close.bind(drawer));
    return true;
  }

  function senkron() {
    var kod = cerezKod();
    if (!kod || mesgul) return;
    var anahtar = kod.toUpperCase();
    /* 25.10: ILK100 kapatıldı; çerezde kalmışsa sepete tekrar eklenmesin, çerez silinsin */
    if (anahtar === 'ILK100') { try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {} return; }
    if ((deneme[anahtar] || 0) >= 2) return; /* Shopify kodu reddederse döngüye girme */
    mesgul = true;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return null; /* boş sepette bekle; ürün eklenince tekrar denenir */
        var mevcut = (cart.discount_codes || []).map(function (d) { return d && d.code; }).filter(Boolean);
        var varMi = mevcut.some(function (c) { return String(c).toUpperCase() === anahtar; });
        if (varMi) return null;
        deneme[anahtar] = (deneme[anahtar] || 0) + 1;
        /* 'discount' alanı sepetteki kodların tamamını değiştirir: mevcut geçerli kodları koru */
        var korunan = (cart.discount_codes || []).filter(function (d) { return d && d.code && d.applicable; })
          .map(function (d) { return d.code; });
        korunan.push(kod);
        var body = { discount: korunan.join(',') };
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); });
      })
      .then(function (res) {
        if (!res || res.status) return;
        var uygulandi = (res.discount_codes || []).some(function (d) { return d && String(d.code).toUpperCase() === anahtar; });
        if (!uygulandi) return;
        if (sepetSayfasi()) {
          var k = 'aq-indirim-yenile-' + anahtar;
          try { if (sessionStorage.getItem(k)) return; sessionStorage.setItem(k, '1'); } catch (e) {}
          window.location.reload();
          return;
        }
        cekmeceyiYenile(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: KAYNAK, cartData: res });
        }
      })
      .catch(function () {})
      .then(function () { mesgul = false; });
  }

  function basla() {
    senkron();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === KAYNAK) return;
        setTimeout(senkron, 300);
      });
    }
    /* Çekmece açılırken (sepet ikonu) son durumu kontrol et */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#cart-icon-bubble')) setTimeout(senkron, 50);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) senkron(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();

/* AQUMIO · Releasit yedeği: çekmece açıldıktan ~1,5 sn sonra Releasit "Kapıda Ödeme" butonu yoksa
   aynı yere (kart butonunun altına) sepet sayfasına (/cart) giden bir Kapıda Ödeme butonu koyar.
   Releasit butonu sonradan gelirse yedek kaldırılır. Ayar: Tema ayarları > AQUMIO – Sepet. */
(function () {
  if (window.aqRsiYedekInit) return;
  window.aqRsiYedekInit = true;
  var BEKLE = 1500;
  var zamanlayici = null;

  function releasitVar(drawer) {
    var w = drawer.querySelector('#cart-wrapper');
    return !!(w && w.querySelector('button, a, [role="button"], ._rsi-buy-now-button, #rsi_buy_now_button'));
  }
  function temizle(drawer) {
    drawer.querySelectorAll('.aq-rsi-yedek').forEach(function (el) { el.remove(); });
  }
  function kontrol() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (releasitVar(drawer)) { temizle(drawer); return; }
    if (!drawer.classList.contains('active')) return;
    var ctas = drawer.querySelector('.aq-sepet-ctas');
    if (!ctas || ctas.getAttribute('data-aq-rsi-yedek') !== 'true') return;
    var bos = drawer.querySelector('.drawer__inner.is-empty') || drawer.classList.contains('is-empty');
    if (bos || drawer.querySelector('.aq-rsi-yedek')) return;
    var a = document.createElement('a');
    a.className = 'aq-rsi-yedek';
    a.href = ctas.getAttribute('data-aq-rsi-url') || '/cart';
    var b = document.createElement('span'); b.className = 'aq-rsi-yedek__ust';
    b.textContent = ctas.getAttribute('data-aq-rsi-baslik') || 'Kapıda Ödeme';
    a.appendChild(b);
    var altMetin = ctas.getAttribute('data-aq-rsi-alt');
    if (altMetin) { var s = document.createElement('span'); s.className = 'aq-rsi-yedek__alt'; s.textContent = altMetin; a.appendChild(s); }
    ctas.parentNode.insertBefore(a, ctas);
  }
  function planla() {
    clearTimeout(zamanlayici);
    zamanlayici = setTimeout(kontrol, BEKLE);
  }
  function basla() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var acik = drawer.classList.contains('active');
    new MutationObserver(function () {
      var simdi = drawer.classList.contains('active');
      if (simdi && !acik) planla();
      acik = simdi;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    /* Çekmece içeriği yeniden çizilince (ürün ekleme, adet değişimi) yeniden kontrol; Releasit gelirse yedeği kaldır */
    new MutationObserver(function () {
      if (releasitVar(drawer)) { temizle(drawer); return; }
      if (drawer.classList.contains('active')) planla();
    }).observe(drawer, { childList: true, subtree: true });
    if (acik) planla();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();

/* 25.10: Renk seçimi -> sayfadaki TÜM sepete-ekle formlarının (Releasit dahil) input[name=id] alanı + ?variant= + change olayı */
(function(){if(window.aqVaryantSenkron)return;window.aqVaryantSenkron=!0;
function secili(){var s=document.querySelector("variant-selects [data-selected-variant]");if(s){try{var v=JSON.parse(s.textContent);if(v&&v.id)return v.id}catch(e){}}var i=document.querySelector("product-form form input[name=id]");return i&&i.value}
function esitle(id){if(!id)return;document.querySelectorAll('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]').forEach(function(i){if(i.closest("cart-drawer, .aq-so"))return;if(String(i.value)!==String(id)){i.value=id;i.dispatchEvent(new Event("input",{bubbles:!0}));i.dispatchEvent(new Event("change",{bubbles:!0}))}});try{var u=new URL(location.href);if(/\/products\//.test(u.pathname)&&u.searchParams.get("variant")!==String(id)){u.searchParams.set("variant",id);history.replaceState(history.state,"",u.toString())}}catch(e){}}
function basla(){if(!/\/products\//.test(location.pathname))return;typeof subscribe=="function"&&typeof PUB_SUB_EVENTS!="undefined"&&subscribe(PUB_SUB_EVENTS.variantChange,function(e){var v=e&&e.data&&e.data.variant;v&&esitle(v.id)});document.addEventListener("change",function(e){e.target&&e.target.closest&&e.target.closest("variant-selects")&&setTimeout(function(){esitle(secili())},350)});esitle(secili());setTimeout(function(){esitle(secili())},1500)}
document.readyState==="loading"?document.addEventListener("DOMContentLoaded",basla):basla()})();
